import React, { useState, useEffect, useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Navbar from "../../components/header/Header";
import UserDetails from "./components/UserDetails";
import SubAccount from "./components/SubAccount";
import "./Settings.scss";
import AssignProjects from "./components/AssignProject";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

const Settings = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [userDetails, setUserDetails] = useState<any>([]);
  const [userId, setUserId] = useState<number>();
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(function () {
      i18n.changeLanguage(localStorage.getItem("lang")!);
    }, 1000);
  }, [i18n.language]);
  return (
    <>
      <Navbar userDetails={userDetails} />
      <div className="grid mt-5" id="tabs">
        <div className="col-12">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="form_tabs"
          >
            <TabPanel header={t("user_settings")} leftIcon="pi pi-user">
              <UserDetails />
            </TabPanel>
            <TabPanel header={t("sub_accounts")} leftIcon="pi pi-user-plus">
              <SubAccount
                onProjectView={(e: any) => {
                  setUserId(e);
                  setActiveIndex(2);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("assign_projects")}
              leftIcon="pi pi-users"
              disabled
            >
              <AssignProjects />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};

export default Settings;
